import { useComputed, useSignal } from '@preact/signals'
import { useMemo } from 'preact/hooks'
import { useParams } from 'wouter-preact'

import {
	Typography,
	DownArrowIcon,
	UpArrowIcon,
	ViewMoreButton,
	HorizontalDivider
} from 'components'
import { isProjectLoadingState } from 'state'
import { dAppsOpen } from 'components/UI/organisms/sidebar/state'

import { SmartContractCard } from './SmartContractCard'

const RecentWorkspaces = () => {
	const { projectId } = useParams()
	const isShowMoreOpened = useSignal(false)
	const currentOpenedDApp = useComputed(() =>
		dAppsOpen.value.filter(dApp => dApp.projectId === projectId)
	)

	const toggleIsOpened = () => {
		isShowMoreOpened.value = !isShowMoreOpened.value
	}

	const dAppsOpenByProject = useMemo(() => {
		if (isShowMoreOpened.value) {
			return currentOpenedDApp.value.filter(
				dApp => dApp.projectId === projectId
			)
		}

		return currentOpenedDApp.value
			.filter(dApp => dApp.projectId === projectId)
			.slice(0, 3)
	}, [projectId, currentOpenedDApp.value, isShowMoreOpened.value])

	if (dAppsOpenByProject.length === 0) return null

	return (
		<>
			<Typography
				color='text-black-100'
				text='Recent workspaces'
				variant='h4'
			/>

			<ul class='mt-4 grid grid-cols-1 gap-4 md:grid-cols-3 lg:gap-5'>
				{dAppsOpenByProject.map(dapp => (
					<SmartContractCard
						id={dapp.id}
						isLoading={isProjectLoadingState.value}
						key={dapp.id}
						name={dapp.name}
					/>
				))}
			</ul>

			{!isProjectLoadingState.value && currentOpenedDApp.value.length > 3 && (
				<div class='mt-3 flex items-center justify-end'>
					<ViewMoreButton
						icon={
							isShowMoreOpened.value ? (
								<UpArrowIcon className='h-2.5 w-2.5 text-black-200 group-hover:text-product' />
							) : (
								<DownArrowIcon className='h-2.5 w-2.5 text-black-200 group-hover:text-product' />
							)
						}
						onClick={toggleIsOpened}
						text={isShowMoreOpened.value ? 'Show less' : 'Show more'}
						variant='small'
					/>
				</div>
			)}

			<HorizontalDivider className='my-5' />
		</>
	)
}

export { RecentWorkspaces }
